export default "/backend/static/media/green.c3754038.png";